import { Html } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useRef, useState } from "react";

interface FpsMonitorProps {
  show: boolean;
}

const SECONDS_IN_MS = 1000;

export const FpsMonitor = ({ show = false }: FpsMonitorProps) => {
  const [fps, setFps] = useState(0);
  const frameCount = useRef(0);
  const lastTime = useRef(performance.now());

  useFrame(() => {
    if (!show) {
      return;
    }

    frameCount.current++;
    const currentTime = performance.now();
    const elapsed = currentTime - lastTime.current;

    // Update FPS display every second
    if (elapsed >= SECONDS_IN_MS) {
      const currentFps = Math.round(
        (frameCount.current * SECONDS_IN_MS) / elapsed
      );
      setFps(currentFps);
      frameCount.current = 0;
      lastTime.current = currentTime;
    }
  });

  if (!show) {
    return null;
  }

  return (
    <Html className="pointer-events-none select-none" position={[0, 0, 0]}>
      <div className="absolute rounded bg-black/80 px-3 py-2 font-mono text-sm font-bold text-[#00ff00]">
        FPS: {fps}
      </div>
    </Html>
  );
};
